var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PhotoSearch',{attrs:{"gallery":_vm.gallery}})}
var staticRenderFns = []

export { render, staticRenderFns }